const ArrowIcon = (props) => (
  <svg
    width={8}
    height={4}
    viewBox='0 0 8 4'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.184985 0.15976C0.431632 -0.0532533 0.831526 -0.0532533 1.07817 0.15976L4 2.68316L6.92183 0.15976C7.16847 -0.0532533 7.56837 -0.0532533 7.81501 0.15976C8.06166 0.372773 8.06166 0.718136 7.81501 0.931149L4.44659 3.84024C4.19995 4.05325 3.80005 4.05325 3.55341 3.84024L0.184985 0.931149C-0.0616617 0.718136 -0.0616617 0.372773 0.184985 0.15976Z'
      fill='currentColor'
    />
  </svg>
);
export default ArrowIcon;
